export const FEATURE_NAME = '@zerops/zerops/core/user-token-base';
